import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import BasicRoutes from "./routes/BasicRoutes";
import "./assets/css/style.css";

function App() {
  return (
    <>
      <BrowserRouter>
        <BasicRoutes />
      </BrowserRouter>
    </>
  );
}

export default App;
